import React from 'react';
import { Switch } from 'antd';
import SummaryHeader from '../SummaryHeader';

// The card and its header: the switch, what it does, and — once it's on — what
// the comparison came to. Whatever the switch reveals is handed in as children.
//
// It owns the card because it owns the one thing that can cancel it. The
// lookups the comparison is built from are watched here and nowhere else, so
// while they load or after they fail there is no card at all, rather than a
// bordered box with nothing in it; and when they land, this is the only part
// that re-renders — children is the same element its parent already made.
const TrendToggle = (props) => {
    const { fetchSurveyLists, fetchOrgRaterGroupsApi } = props;

    // Offered only once the visualizations have reported and none of them found
    // too few leaders to show results for. Waiting for that verdict is the point
    // — before any of them answers there is nothing saying the dataset is big
    // enough, and offering the comparison then only to withdraw it a moment
    // later is worse than showing it a moment late.
    if (!props.isLeaderGateMet && !props.isTrendComparison) return null;

    if (fetchSurveyLists.isProcessing || fetchOrgRaterGroupsApi.isProcessing
        || fetchSurveyLists.error || fetchOrgRaterGroupsApi.error) {
        return null;
    }
    return (
        <div className='cardwrapper'>
            <div className='comparison-wrapper'>
                <span>
                    <Switch checked={props.isTrendComparison} onChange={(value) => { props.handleChangeTrendToggle(value) }} />
                </span>
                <div className='comparison-wrapper__description'>
                    <span className='label-header'> Compare against earlier feedback</span>
                    <span className='label-description'> Each participant is matched to their own earlier 360 by email address.</span>
                    {/* What that matching came to — only once there is a
                        comparison to sum up. */}
                    {props.isTrendComparison && <SummaryHeader />}
                </div>
            </div>

            {props.children}
        </div>
    );
};

export default TrendToggle;
